import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/maximo-app-framework/maximo-autoscript-documentation/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Flows`}</h2>
    <p>{`The following figure provides a visual feel for the design and run-time artifacts for Maximo Manage scripting.`}</p>
    <h3>{`Design Flow`}</h3>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "981px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.66666666666666%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAIB/9oADAMBAAIQAxAAAAHpWEc6Rz//xAAZEAEBAQADAAAAAAAAAAAAAAABAiEAMUH/2gAIAQEAAQUC8JEnqY3Sy+f/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPwGo/8QAHxAAAgECBwAAAAAAAAAAAAAAAAERITECQlGRkuHx/9oACAEBAAY/AnR8xYq21PRzGxGWLHZ//8QAGxAAAgMAAwAAAAAAAAAAAAAAAAERITFBUZH/2gAIAQEAAT8hoVsAoRcfsUKE6byphNLgIqx+z//aAAwDAQACAAMAAAAQPA//xAAXEQEBAQEAAAAAAAAAAAAAAAABABEx/9oACAEDAQE/EAzsN//EABcRAAMBAAAAAAAAAAAAAAAAAAABETH/2gAIAQIBAT8QdYNqf//EAB0QAQABBQADAAAAAAAAAAAAAAERACExQVFxgcH/2gAIAQEAAT8QEYwTS93c2qcZQJB7jNRKzPVo6UOg6AIbv2ogMTCl/NPPttftf//Z')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Script Design flow",
        "title": "Script Design flow",
        "src": "/maximo-autoscript-documentation/static/475c77c1e735f335968f4df34b4f890b/1f59a/scriptflow.jpg",
        "srcSet": ["/maximo-autoscript-documentation/static/475c77c1e735f335968f4df34b4f890b/69549/scriptflow.jpg 288w", "/maximo-autoscript-documentation/static/475c77c1e735f335968f4df34b4f890b/473e3/scriptflow.jpg 576w", "/maximo-autoscript-documentation/static/475c77c1e735f335968f4df34b4f890b/1f59a/scriptflow.jpg 981w"],
        "sizes": "(max-width: 981px) 100vw, 981px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h3>{`Runtime Flow`}</h3>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "886px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "22.916666666666668%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAFABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAIF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB2glgf//EABcQAQEBAQAAAAAAAAAAAAAAAAECABH/2gAIAQEAAQUCmaNMpg5v/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Bp//EABkQAAMAAwAAAAAAAAAAAAAAAAACEQEhMf/aAAgBAQAGPwLNem3p2n//xAAZEAACAwEAAAAAAAAAAAAAAAABEQAhMXH/2gAIAQEAAT8hAMNlZHbuxDBZ9T//2gAMAwEAAgADAAAAEPfP/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8Qh//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/EFT/xAAZEAEBAQEBAQAAAAAAAAAAAAABEQAhYZH/2gAIAQEAAT8QNU20gxbo5IE+ZIMqtATzm//Z')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Script Runtime flow",
        "title": "Script Runtime flow",
        "src": "/maximo-autoscript-documentation/static/0dae4dab47672ea2613cbdc91688835a/01d2f/scriptrflow.jpg",
        "srcSet": ["/maximo-autoscript-documentation/static/0dae4dab47672ea2613cbdc91688835a/69549/scriptrflow.jpg 288w", "/maximo-autoscript-documentation/static/0dae4dab47672ea2613cbdc91688835a/473e3/scriptrflow.jpg 576w", "/maximo-autoscript-documentation/static/0dae4dab47672ea2613cbdc91688835a/01d2f/scriptrflow.jpg 886w"],
        "sizes": "(max-width: 886px) 100vw, 886px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      